import React from "react";
import "./IndustriesSection.css";
import { resolveAssetUrl } from "../utils/assets";

const IndustriesSection = ({ data }) => {
  const items = data?.items || [];

  return (
    <section className="industries-section">
      <div className="industries-header">
        {data?.subtitle && <span>{data.subtitle}</span>}
        {data?.title && <h2>{data.title}</h2>}
        {data?.description && <p>{data.description}</p>}
      </div>

      <div className="industries-grid">
        {items.map((item, index) => {
          const imageSrc = resolveAssetUrl(item.image) || item.image || "";
          return (
            <div className="industry-card" key={`${item.title}-${index}`}>
              <div
                className="industry-image"
                style={{
                  backgroundImage: imageSrc ? `url(${imageSrc})` : undefined,
                }}
              />
              <div className="industry-overlay" />
              <div className="industry-content">
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default IndustriesSection;
